import styled from 'styled-components';

const Root = styled.div`
  margin-right: 0.75rem;
  display: flex;
  align-items: center;
  .seperator {
    color: var(--outline);
    margin: 0 0.375rem;
  }
  .counts {
    font-size: 0.875rem;
    color: var(--text-disabled);
  }
  .selected-counts {
    display: flex;
    align-items: center;
    padding: 0 0.25rem;
    border-radius: 100%;
    height: 1.5rem;
    min-width: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    &.gray {
      background-color: var(--tonal);
      color: var(--text-disabled);
    }
    &.green {
      background-color: var(--tonal-green);
      color: var(--filled-green);
    }
    &.blue {
      background-color: var(--tonal-blue);
      color: var(--primary);
    }
  }
`;

interface Props {
  count: number;
  totalCount: number;
}

const CountBoxInModal = ({ count, totalCount }: Props) => {
  const getColor = () => {
    if (count === 0) return 'gray';
    if (count === totalCount) return 'blue';
    return 'green';
  };
  const countStyle = `selected-counts counts ${getColor() ?? 'gray'}`;

  return (
    <Root className='counts-container'>
      <span className={countStyle}>{count}</span>
      <span className='total-counts counts'>
        <span className='seperator'>/</span>
        {totalCount}
      </span>
    </Root>
  );
};

export default CountBoxInModal;
